import { observer } from 'mobx-react';
import { chatStore } from '../../ChatStores/ChatStore';
import ChatStream from './ChatStream';
import ConversationHistory from './ConversationHistory';
import Header from './Header';
import useScrollHandling from '../Hooks/useScrollHandling';
import { MutableRefObject } from 'react';
import { Message } from '../../ChatStores/ChatStore/Types';

interface Props {
  messagesEndRef: MutableRefObject<HTMLDivElement | null>;
  messages: Message[];
}

function Messages({ messagesEndRef, messages }: Props) {
  const { handleScroll } = useScrollHandling(messagesEndRef);
  return (
    <div ref={messagesEndRef} className="overflow-auto flex h-full" onScroll={handleScroll}>
      <div className="flex flex-col mt-auto">
        <Header />
        <ConversationHistory messages={messages} />
        <ChatStream chatStore={chatStore} />
      </div>
    </div>
  );
}

export default observer(Messages);
